<script>
import { Sprite, Container } from 'pixi.js'
import SceneMixin from '@/mixins/Scene'

export default {
  name: 'Scene8',
  mixins: [ SceneMixin ],
  beforeDestroy() {
    console.log('beforeDestroy');
    _.each(this.$sprites, (sp, index)=>{
      if(this.$els[index]) this.$els[index]['container'].removeChild(sp)
    })
    this.$container.removeChild(this.$scene)
    this.$sub1.kill()
    this.$sub2.kill()
  },

  created() {

    const sprites = {}
    this.$sprites = sprites

    this.$scene = new Container 
    this.$scene.interactiveChildren = false
    
    this.$container.addChild(this.$scene)
    this.$parent.$scene8 = this.$scene

    const container = new Container()
          container.alpha = 0
    this.setCenterContainer(container)   
    this.$scene.addChild(container)

    this.$sub1 = new TimelineMax()
    this.$sub2 = new TimelineMax()

    // ******************************************************** //
    // ******************************************************** //

    let medium = (this.$root.above('tablet')) 
        ? { ref: 'medium_8', container: container, alpha: 1 }
        : { ref: 'medium_quart', container: container, alpha: 1, scale: 2 }

    const els = {
      'ensemble': { container: container, alpha: 1 },
      'crowd': { container: container, alpha: 1 },
      'bancs': { container: container, alpha: 1 },
      'medium': medium,
      'tables': { container: container, alpha: 1 },
      'center1_s8': { container: container, alpha: 1 },
      'center2_s8': { container: container, alpha: 1 },
      'center3_s8': { container: container, alpha: 1 },
      'trone': { container: container, alpha: 0 },
      'front_s8': { container: container, alpha: 0 },
      'speaker_s8': { container: container, alpha: 1 },
      'speaker_large': { container: container, alpha: 0, scale: this.$root.$scale*0.28, x:-1, y: 123 },
    }

    _.each(els, (el, name)=>{
      let sp = null
      const _name = (el.ref) ? el.ref : name
      const sprite = new Sprite.from(this.$resources[_name].texture) 
            sprite.scale.set(this.$root.$scale)
            sprite.anchor.set(.5)
            sprite.alpha = el.alpha
      if(!el.pivot) { sp = sprite }
      else {
        const cn = new Sprite()
        sprite.x = el.pivot.x/2
        sprite.y = el.pivot.y/2 
        cn.addChild(sprite)
        sp = cn
      }
      el.container.addChild(sp)
      sprites[name] = sp
      this.applySettings(sp, el)
    })

    this.$els = els

    // ******************************************************** //
    // ******************************************************** //

    const tempo = .55
    const personnages = [ sprites['center1_s8'], sprites['center2_s8'], sprites['center3_s8'] ]

    // const alphaFilter = new PIXI.filters.AlphaFilter(0.0)
    // container.filters = [ alphaFilter ]

    const percent = (this.$root.above('tablet')) ? .2 : .4

    this.$sub2


      // .to(alphaFilter, 1, { alpha: 1, ease: Linear.easeNone, onComplete: ()=>{ container.filters = null } })
      .to(container, 1, { alpha: 1, ease: Linear.easeNone })

      .add([
        TweenMax.to(sprites['ensemble'], tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -680, blur: 4 }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['crowd'], tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -680, blur: 4 }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['bancs'], tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -680 }, ease: Cubic.easeIn }), 
        TweenMax.to(sprites['speaker_s8'], tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -670 }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['speaker_large'], tempo*8, { pixi:{ scale: this.$root.$scale*1.39, x: -.5, y: -57.25, alpha: 1 }, ease: Cubic.easeIn }), 
        TweenMax.from(sprites['medium'], tempo*8, { pixi:{ scale: this.$root.$scale_optimize*percent, x: -2, y: 134, blur:1 }, ease: Cubic.easeIn }),   
        TweenMax.to(sprites['tables'], tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -500 }, ease: Cubic.easeIn }),
        TweenMax.to(sprites['tables'], tempo*0.5, { pixi:{ alpha: 0 }, ease: Cubic.easeIn, delay: tempo*6.5 }),    
        TweenMax.to(personnages, tempo*8, { pixi:{ scale: this.$root.$scale*4.96, x: 5, y: -500 }, ease: Cubic.easeIn }),
        TweenMax.to(personnages, tempo*0.5, { pixi:{ alpha: 0 }, ease: Linear.easeNone, delay: tempo*6.5 }),
        TweenMax.to(sprites['medium'], tempo*0.5, { pixi:{ alpha: 1 }, ease: Linear.easeNone, delay: tempo*2 }),
      ])

    this.$sub1
      .add([ this.$sub2 ])
      .to(sprites['front_s8'], .25, { pixi:{ alpha: 1 }, ease: Linear.easeNone })

    this.$tl.add([ this.$sub1 ], 70)

  },
  mounted() {

    // console.log('Scene8');
    // this.$parent.chapter.$tl.seek(66)
    
  }
}
</script>























